import { render, staticRenderFns } from "./HeadTitle.vue?vue&type=template&id=2ea5fba8&scoped=true&"
import script from "./HeadTitle.vue?vue&type=script&lang=js&"
export * from "./HeadTitle.vue?vue&type=script&lang=js&"
import style0 from "./HeadTitle.vue?vue&type=style&index=0&id=2ea5fba8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea5fba8",
  null
  
)

export default component.exports